import { createSelector } from 'reselect';
import { get, sortBy } from 'lodash';

const selectClient = state => state.modals.Project.client;

export default createSelector(
  selectClient,
  (client) => sortBy(get(client, 'client_contacts', []), ['first_name', 'last_name'])
)